import {
  SnippetElement,
  defineElement
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-product-card/common-product-card.ts
var CommonProductCard = class extends SnippetElement {
};
CommonProductCard = __decorateClass([
  defineElement("common-product-card")
], CommonProductCard);
export {
  CommonProductCard
};
